var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 115.24 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #690a20;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #020031;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0,
    y: 7,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 3.5,
    y: 10.5,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 7,
    y: 10.5,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 7,
    y: 14,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 10.5,
    y: 14,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 14,
    y: 14,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 17.5,
    y: 14,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 21,
    y: 14,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 24.5,
    y: 14,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 10.5,
    y: 17.5,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 14,
    y: 17.5,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 17.5,
    y: 17.5,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 21,
    y: 17.5,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 24.5,
    y: 17.5,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 28,
    y: 17.5,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 14,
    y: 21,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 17.5,
    y: 21,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 21,
    y: 21,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 24.5,
    y: 21,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 28,
    y: 21,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 31.5,
    y: 21,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 35,
    y: 21,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 38.5,
    y: 21,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 19.12,
    y: 24.5,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 22.62,
    y: 24.5,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 26.12,
    y: 24.5,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 29.62,
    y: 24.5,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 33.12,
    y: 24.5,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 36.62,
    y: 24.5,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 40.12,
    y: 24.5,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 43.62,
    y: 24.5,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 47.12,
    y: 24.5,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 50.62,
    y: 24.5,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 54.12,
    y: 24.5,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 57.62,
    y: 24.5,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 61.12,
    y: 24.5,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 64.62,
    y: 24.5,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 68.12,
    y: 24.5,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 71.62,
    y: 24.5,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 111.74,
    y: 7,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 108.24,
    y: 10.5,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 104.74,
    y: 10.5,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 104.74,
    y: 14,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 101.24,
    y: 14,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 97.74,
    y: 14,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 94.24,
    y: 14,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 90.74,
    y: 14,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 87.24,
    y: 14,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 101.24,
    y: 17.5,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 97.74,
    y: 17.5,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 94.24,
    y: 17.5,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 90.74,
    y: 17.5,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 87.24,
    y: 17.5,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 83.74,
    y: 17.5,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 97.74,
    y: 21,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 94.24,
    y: 21,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 90.74,
    y: 21,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 87.24,
    y: 21,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 83.74,
    y: 21,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 80.24,
    y: 21,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 76.74,
    y: 21,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 73.24,
    y: 21,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 92.62,
    y: 24.5,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 89.12,
    y: 24.5,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 85.62,
    y: 24.5,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 82.12,
    y: 24.5,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 78.62,
    y: 24.5,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 75.12,
    y: 24.5,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 22.62,
    y: 28,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 26.12,
    y: 28,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 29.62,
    y: 28,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 33.12,
    y: 28,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 36.62,
    y: 28,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 40.12,
    y: 28,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 43.62,
    y: 28,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 47.12,
    y: 28,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 50.62,
    y: 28,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 54.12,
    y: 28,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 57.62,
    y: 28,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 61.12,
    y: 28,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 64.62,
    y: 28,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 68.12,
    y: 28,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 71.62,
    y: 28,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 89.12,
    y: 28,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 85.62,
    y: 28,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 82.12,
    y: 28,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 78.62,
    y: 28,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 75.12,
    y: 28,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 26.12,
    y: 31.5,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 29.62,
    y: 31.5,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 33.12,
    y: 31.5,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 36.62,
    y: 31.5,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 40.12,
    y: 31.5,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 43.62,
    y: 31.5,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 47.12,
    y: 31.5,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 50.62,
    y: 31.5,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 54.12,
    y: 31.5,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 57.62,
    y: 31.5,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 61.12,
    y: 31.5,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 64.62,
    y: 31.5,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 68.12,
    y: 31.5,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 71.62,
    y: 31.5,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 85.62,
    y: 31.5,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 82.12,
    y: 31.5,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 78.62,
    y: 31.5,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 75.12,
    y: 31.5,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 29.62,
    y: 35,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 33.12,
    y: 35,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 36.62,
    y: 35,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 40.12,
    y: 35,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 43.62,
    y: 35,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 47.12,
    y: 35,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 50.62,
    y: 35,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 54.12,
    y: 35,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 57.62,
    y: 35,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 61.12,
    y: 35,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 64.62,
    y: 35,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 68.12,
    y: 35,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 71.62,
    y: 35,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 82.12,
    y: 35,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 78.62,
    y: 35,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 75.12,
    y: 35,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 33.13,
    y: 38.5,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 36.63,
    y: 38.5,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 40.13,
    y: 38.5,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 43.63,
    y: 38.5,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 47.13,
    y: 38.5,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 50.63,
    y: 38.5,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 54.13,
    y: 38.5,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 57.63,
    y: 38.5,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 61.13,
    y: 38.5,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 64.63,
    y: 38.5,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 68.13,
    y: 38.5,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 71.63,
    y: 38.5,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 78.62,
    y: 38.5,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 75.12,
    y: 38.5,
    width: 3.5,
    height: 3.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 48.87,
    y: 21,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 48.87,
    y: 17.5,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 48.88,
    y: 14,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 48.88,
    y: 10.5,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 52.37,
    y: 21,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 55.87,
    y: 21,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 59.37,
    y: 21,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 62.87,
    y: 21,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 62.88,
    y: 17.5,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 62.88,
    y: 14,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 62.88,
    y: 10.5,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 52.05,
    y: 3.5,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 55.55,
    y: 17.5,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 55.55,
    y: 14,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 55.55,
    y: 10.5,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 48.55,
    y: 0,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 55.55,
    y: 7,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 59.05,
    y: 3.5,
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 62.55,
    y: 0,
    width: 3.5,
    height: 3.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShip);
export default __webpack_public_path__ + "static/media/ship.a0817b28e1af1318f72fa63a7db6acb0.svg";
export { ForwardRef as ReactComponent };